// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LoadingSpinner_wrapper__mHDsG","visible":"LoadingSpinner_visible__ta3_S"};